import sanitizeSearchQueryForLog from '@/components/TypeAhead/sanitize-search-query-for-log'
import analytics from '@/shared-utils/analytics'

// cguid, page URL and device are attached to every browser log by the beacon —
// these only carry what is specific to the event.

/** Splunk: message=ai_search_mode_toggle */
export function logAiSearchModeToggle(toMode: string) {
  analytics.log({
    message: 'ai_search_mode_toggle',
    toMode,
  })
}

/** Splunk: message=ai_search_no_recommendations_switch_to_standard */
export function logAiSearchNoRecommendationsSwitch(searchQuery: string) {
  analytics.log({
    message: 'ai_search_no_recommendations_switch_to_standard',
    searchQuery: sanitizeSearchQueryForLog(searchQuery),
  })
}

/** Splunk: message=ai_search_resolve_failed */
export function logAiSearchResolveFailed(searchQuery: string) {
  analytics.log({
    message: 'ai_search_resolve_failed',
    searchQuery: sanitizeSearchQueryForLog(searchQuery),
  })
}

/** Splunk: message=ai_search_request_failed */
export function logAiSearchRequestFailed(searchQuery: string) {
  analytics.log({
    message: 'ai_search_request_failed',
    searchQuery: sanitizeSearchQueryForLog(searchQuery),
  })
}
